import { render } from "./Sidebar.vue?vue&type=template&id=1492843c&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=1492843c&scoped=true&lang=css"

import exportComponent from "/Users/christianreyes/Documents/Proyectos/buzon/buzon-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1492843c"]])

export default __exports__